module.exports = __webpack_public_path__ + "img/food.1aaa7ea9.png";